import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faUsers,
  faRightFromBracket,
  faBook,
  faListCheck,
  faCartShopping,
  faBagShopping,
} from "@fortawesome/free-solid-svg-icons";
import config from '../functions/config';


const AdminDashboard = () => {
  const handleNavigation = (route) => {
    window.location.href = route;
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light fixed-top">
        <a className="navbar-brand text-light" href="#">
          Admin <FontAwesomeIcon icon={faTachometerAlt} />
        </a>
        <button
          className="navbar-toggler bg-light"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto pr-5">
            <li className="nav-item mr-5">
              <a className="nav-link text-light fixed-right" href="/login">
                <FontAwesomeIcon icon={faRightFromBracket} /> Logout
              </a>
            </li>
          </ul>
        </div>
      </nav>

      {/* Dashboard Header */}
      <div className="container my-4 mt-5 pt-5">
        <h1 className="text-center">Welcome to the Admin Dashboard</h1>
        <p className="text-center text-muted">
          Here, you can manage all library activities from book registration to user management and rental tracking.
        </p>
      </div>

  
      {/* Dashboard Cards */}
      <div className="container  justify-content-center">
        <div className="row row-cols-1 row-cols-md-4  justify-content-center">
          {/* Register Book Card */}
          <div className="col">
            <div className="card shadow-lg border-primary" onClick={() => handleNavigation('/register-book')}>
              <div className="card-body text-center p-4">
                <FontAwesomeIcon icon={faBook} size="2x" className="mb-3 text-primary" />
                <h5 className="card-title text-primary">Register Book</h5>
                <p className="card-text">Add new books to the library. Manage book details effectively.</p>
              </div>
            </div>
          </div>

          {/* Manage Books Card */}
          <div className="col">
            <div className="card shadow-lg border-success" onClick={() => handleNavigation('/view-books')}>
              <div className="card-body text-center p-4">
                <FontAwesomeIcon icon={faListCheck} size="2x" className="mb-3 text-success" />
                <h5 className="card-title text-success">Manage Books</h5>
                <p className="card-text">View, edit, and delete books from the library's collection.</p>
              </div>
            </div>
          </div>

          {/* Manage Users Card */}
          <div className="col">
            <div className="card shadow-lg border-info" onClick={() => handleNavigation('/list-users')}>
              <div className="card-body text-center p-4">
                <FontAwesomeIcon icon={faUsers} size="2x" className="mb-3 text-info" />
                <h5 className="card-title text-info">Manage Users</h5>
                <p className="card-text">Approve, remove or edit users. Manage user privileges effectively.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="row row-cols-1 row-cols-md-4 mt-3 g-4 justify-content-center">
          {/* Rental History Card */}
          <div className="col">
            <div className="card shadow-lg border-danger" onClick={() => handleNavigation('/adminrent')}>
              <div className="card-body text-center p-4">
                <FontAwesomeIcon icon={faCartShopping} size="2x" className="mb-3 text-danger" />
                <h5 className="card-title text-danger">Rental History</h5>
                <p className="card-text">Track user rental activities, including rental start dates, due dates, and fines.</p>
              </div>
            </div>
          </div>

          {/* Purchase History Card */}
          <div className="col">
            <div className="card shadow-lg border-warning" onClick={() => handleNavigation('/adminpurchase')}>
              <div className="card-body text-center p-4">
                <FontAwesomeIcon icon={faBagShopping} size="2x" className="mb-3 text-warning" />
                <h5 className="card-title text-warning">Purchase History</h5>
                <p className="card-text">Track user purchase activities including book purchases and payment statuses.</p>
              </div>
            </div>
          </div>

          {/* Logout Card */}
          <div className="col">
            <div className="card shadow-lg border-secondary py-4" onClick={() => handleNavigation('/login')}>
              <div className="card-body text-center p-4">
                <FontAwesomeIcon icon={faRightFromBracket} size="2x" className="mb-3 text-secondary" />
                <h5 className="card-title text-secondary">Logout</h5>
                <p className="card-text">Logout from the admin panel.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Dashboard Footer */}
      <div className="container text-center mt-5">
        <p className="text-muted">© 2025 Library Management System. All rights reserved.</p>
      </div>

      <style jsx>{`
        body {
          position: relative;
          margin: 0;
          padding: 0;
        }

        body::before {
          content: '';
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: url('https://i.ytimg.com/vi/wPPXPx9S_Ms/maxresdefault.jpg') no-repeat center center fixed;
          background-size: cover;
          opacity: 0.1;
          z-index: -1;
        }

        .content {
          margin-left: 200px;
        }

        @media (max-width: 768px) {
          .vertical-nav {
            width: 100%;
          }
          .content {
            margin-left: 0;
          }
        }

        .navbar {
          background: #1a1a1a;
        }

        .vertical-nav {
          background: #1a1a1a;
          position: fixed;
          top: 56px;
          left: 0;
          height: calc(100% - 56px);
          overflow-y: auto;
          padding-top: 30px;
          z-index: 999;
        }

        .vertical-nav .nav-link {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding: 10px 15px;
          color: #ff6700;
          transition: background-color 0.3s;
        }

        .vertical-nav .nav-link:hover {
          background-color: #2a2a2a;
        }

        .nav-icon {
          font-size: 20px;
          margin-right: 10px;
          color: #ff6700;
        }

        li {
          border-bottom: 2px solid black;
        }

        li:hover {
          background-color: #2a2a2a;
        }

        h1, h2, h3, h4, h5, h6 {
          font-family: "Times New Roman", Times, serif;
          color: #1a1a1a;
        }

        .d-flex {
          display: flex;
          flex-direction: column;
          min-height: 100vh;
        }

        .flex-grow-1 {
          flex-grow: 1;
        }
      `}</style>
    </div>
  );
};

export default AdminDashboard;
